import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Nav } from './Nav';
import { Footer } from './Footer';

/**
 * Application shell shared by every route. Renders the navigation, the matched
 * route content, and the footer. Resets scroll on route change so the user
 * always lands at the top of a new page (preserving in-page anchors).
 */
export function Layout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return (
    <>
      <Nav />
      <Outlet />
      <Footer />
    </>
  );
}
